import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';

@Component({
  selector: 'app-linkpolicy',
  templateUrl: './linkpolicy.component.html',
  styleUrls: ['./linkpolicy.component.scss'],
})
export class LinkpolicyComponent implements OnInit {
  headerTitle: any;
  PolicyList: any;
  SelectedPolicy: any = [];
  Nonselected: any = [];
  AddPolicy: any = [{ policyNo: "" }];
  langcontext: any;
  ClientId: any;
  constructor(public platform: Platform, public navctrl: NavController, public api: RestapiService, public cmndecl: CommonDeclarationService, public cmndec: CommonDefinitionService) {
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['linkpolicy'];
      this.headerTitle = this.langcontext.heading.label;
    }
    else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].linkpolicy;
      this.headerTitle = this.langcontext.heading.label;
    }
    this.getPolicyDetails();
  }

  ngOnInit() {

  }

  getPolicyDetails() {
    let req: any;
    req = {
      "mobileNo": "",
      "userSessionID": localStorage.userSessionID,
      "userChatSessionId": localStorage.userChatSessionId
    }
    this.cmndec.loaderstart();
    this.api.postapi("getPolicyList", req).then((data: any) => {
      this.PolicyList = data.policyList;
      for (let i = 0; i < this.PolicyList.length; i++) {
        if (this.PolicyList[i].policySelectStatus == 1){
          this.SelectedPolicy.push(this.PolicyList[i]);
          this.ClientId= this.PolicyList[i].pnbCustomerID;
        }
        else
          this.Nonselected.push(this.PolicyList[i]);
      }
      this.cmndec.loaderend();
    }, err => {
      console.log(err);
      this.cmndec.loaderend();
    })
  }

  addpolicy(flg) {
    if (flg == "yes")
      this.AddPolicy.push({ policyNo: "" })
    else
      this.AddPolicy = []
  }

  policyAdd(idx) {
    if (this.AddPolicy.length < 5)
      if (this.AddPolicy[idx].policyNo.length == 8)
        this.AddPolicy.push({ policyNo: "" });
  }

  deletepolicy(idx) {
    console.log(idx);
    this.AddPolicy.splice(idx, 1);
  }

  validatefun(idx) {
    this.AddPolicy[idx].policyNo = this.AddPolicy[idx].policyNo.replace(/[^0-9]/g, '');
  }

  async submit() {
    let errflg = false;
    let policy = "";
    let req: any;
    for (let i = 0; i < this.AddPolicy.length; i++) {
      console.log(this.AddPolicy[i].policyNo);
      if (this.AddPolicy[i].policyNo.length != 0 && this.AddPolicy[i].policyNo.length < 8) {
        errflg = true;
        break;
      } else if (this.AddPolicy[i].policyNo.length != 0) {
        if (policy == "")
          policy = policy + this.AddPolicy[i].policyNo;
        else
          policy = policy + "," + this.AddPolicy[i].policyNo;
      }
    }
    if (!errflg) {
      this.cmndec.loaderstart();
      req = {
        "userSessionID": localStorage.userSessionID,
        "userChatSessionID": localStorage.userChatSessionId,
        "actionType": "ClientId_merge",
        "clientId": this.ClientId,
        "policyDetails": policy
      }
      console.log(req);
      this.api.clickenventcap("submit_" + this.cmndec.TrakcerFromValue[this.cmndec.router.url]);
      await this.api.postapi("akeiraVAAction", req).then(async data => {
        let res = data;
        this.cmndec.loaderend();
        this.cmndecl.TamlismaJson = res["chatResp"][0];
        sessionStorage.CurrentPage = "/va/chat";
        this.navctrl.navigateForward("/va/chat");
      }, err => {
        console.log(err);
        this.cmndec.loaderend();
      })
    }
  }

  validatepolicy() {
    for (let i = 0; i < this.AddPolicy.length; i++) {
      if (this.AddPolicy[i].policyNo != "") {
        return false;
        break;
      }
    }
    return true;
  }


}
